import type { StyleSpecification } from "maplibre-gl";

export const mapStyle: StyleSpecification = {
	version: 8,
	name: "WAYF Dark",
	sources: {
		openmaptiles: {
			type: "vector",
			url: "https://tiles.openfreemap.org/planet"
		}
	},
	glyphs: "https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf",
	sprite: "https://tiles.openfreemap.org/sprites/liberty/sprite",
	layers: [
		{
			id: "background",
			type: "background",
			paint: {
				"background-color": "#1a1a2e"
			}
		},
		{
			id: "water",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "water",
			paint: {
				"fill-color": "#16213e"
			}
		},
		{
			id: "landcover-grass",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "landcover",
			filter: ["==", "class", "grass"],
			paint: {
				"fill-color": "#1e2a3a"
			}
		},
		{
			id: "landcover-wood",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "landcover",
			filter: ["==", "class", "wood"],
			paint: {
				"fill-color": "#1a2535"
			}
		},
		{
			id: "landuse-residential",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "landuse",
			filter: ["==", "class", "residential"],
			paint: {
				"fill-color": "#202040"
			}
		},
		{
			id: "landuse-commercial",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "landuse",
			filter: ["in", "class", "commercial", "industrial"],
			paint: {
				"fill-color": "#1f1f3a"
			}
		},
		{
			id: "landuse-park",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "landuse",
			filter: ["==", "class", "park"],
			paint: {
				"fill-color": "#1a2a35"
			}
		},
		{
			id: "building",
			type: "fill",
			source: "openmaptiles",
			"source-layer": "building",
			minzoom: 13,
			paint: {
				"fill-color": "#252545",
				"fill-opacity": 0.8
			}
		},
		{
			id: "building-outline",
			type: "line",
			source: "openmaptiles",
			"source-layer": "building",
			minzoom: 13,
			paint: {
				"line-color": "#303055",
				"line-width": 1
			}
		},
		{
			id: "tunnel-path",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "tunnel"], ["==", "class", "path"]],
			paint: {
				"line-color": "#2a2a4a",
				"line-width": 1,
				"line-dasharray": [2, 2]
			}
		},
		{
			id: "tunnel-street",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "tunnel"], ["in", "class", "street", "minor"]],
			paint: {
				"line-color": "#2a2a4a",
				"line-width": ["interpolate", ["linear"], ["zoom"], 12, 1, 16, 6]
			}
		},
		{
			id: "tunnel-secondary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "tunnel"], ["==", "class", "secondary"]],
			paint: {
				"line-color": "#303050",
				"line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 16, 8]
			}
		},
		{
			id: "tunnel-primary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "tunnel"], ["==", "class", "primary"]],
			paint: {
				"line-color": "#353560",
				"line-width": ["interpolate", ["linear"], ["zoom"], 8, 1, 16, 10]
			}
		},
		{
			id: "road-path",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "path"]],
			paint: {
				"line-color": "#3a3a5a",
				"line-width": 1,
				"line-dasharray": [2, 2]
			}
		},
		{
			id: "road-service",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "service"]],
			minzoom: 13,
			paint: {
				"line-color": "#35355a",
				"line-width": ["interpolate", ["linear"], ["zoom"], 13, 1, 16, 4]
			}
		},
		{
			id: "road-street",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["in", "class", "street", "minor"]],
			paint: {
				"line-color": "#3a3a60",
				"line-width": ["interpolate", ["linear"], ["zoom"], 12, 1, 16, 6]
			}
		},
		{
			id: "road-tertiary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "tertiary"]],
			paint: {
				"line-color": "#404065",
				"line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 16, 7]
			}
		},
		{
			id: "road-secondary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "secondary"]],
			paint: {
				"line-color": "#45456a",
				"line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 16, 9]
			}
		},
		{
			id: "road-primary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "primary"]],
			paint: {
				"line-color": "#4a4a70",
				"line-width": ["interpolate", ["linear"], ["zoom"], 8, 1, 16, 11]
			}
		},
		{
			id: "road-trunk",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "trunk"]],
			paint: {
				"line-color": "#0f3460",
				"line-width": ["interpolate", ["linear"], ["zoom"], 6, 1, 16, 14]
			}
		},
		{
			id: "road-motorway",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["!has", "brunnel"], ["==", "class", "motorway"]],
			paint: {
				"line-color": "#0f3460",
				"line-width": ["interpolate", ["linear"], ["zoom"], 5, 1, 16, 16]
			}
		},
		{
			id: "bridge-street",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "bridge"], ["in", "class", "street", "minor"]],
			paint: {
				"line-color": "#3a3a60",
				"line-width": ["interpolate", ["linear"], ["zoom"], 12, 1, 16, 6]
			}
		},
		{
			id: "bridge-primary",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "bridge"], ["in", "class", "primary", "secondary", "tertiary"]],
			paint: {
				"line-color": "#45456a",
				"line-width": ["interpolate", ["linear"], ["zoom"], 8, 1, 16, 10]
			}
		},
		{
			id: "bridge-motorway",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["all", ["==", "brunnel", "bridge"], ["in", "class", "motorway", "trunk"]],
			paint: {
				"line-color": "#0f3460",
				"line-width": ["interpolate", ["linear"], ["zoom"], 5, 1, 16, 14]
			}
		},
		{
			id: "rail",
			type: "line",
			source: "openmaptiles",
			"source-layer": "transportation",
			filter: ["==", "class", "rail"],
			paint: {
				"line-color": "#4a4a6a",
				"line-width": 2,
				"line-dasharray": [3, 3]
			}
		},
		{
			id: "waterway",
			type: "line",
			source: "openmaptiles",
			"source-layer": "waterway",
			paint: {
				"line-color": "#16213e",
				"line-width": ["interpolate", ["linear"], ["zoom"], 8, 1, 16, 4]
			}
		},
		{
			id: "boundary-country",
			type: "line",
			source: "openmaptiles",
			"source-layer": "boundary",
			filter: ["==", "admin_level", 2],
			paint: {
				"line-color": "#505080",
				"line-width": 1.5,
				"line-dasharray": [4, 2]
			}
		},
		{
			id: "road-label",
			type: "symbol",
			source: "openmaptiles",
			"source-layer": "transportation_name",
			minzoom: 14,
			layout: {
				"text-field": "{name}",
				"text-font": ["Noto Sans Regular"],
				"text-size": 10,
				"symbol-placement": "line",
				"text-rotation-alignment": "map"
			},
			paint: {
				"text-color": "#8080a0",
				"text-halo-color": "#1a1a2e",
				"text-halo-width": 1
			}
		},
		{
			id: "place-suburb",
			type: "symbol",
			source: "openmaptiles",
			"source-layer": "place",
			filter: ["==", "class", "suburb"],
			minzoom: 12,
			layout: {
				"text-field": "{name}",
				"text-font": ["Noto Sans Regular"],
				"text-size": 12
			},
			paint: {
				"text-color": "#9090b0",
				"text-halo-color": "#1a1a2e",
				"text-halo-width": 1
			}
		},
		{
			id: "place-town",
			type: "symbol",
			source: "openmaptiles",
			"source-layer": "place",
			filter: ["==", "class", "town"],
			minzoom: 8,
			layout: {
				"text-field": "{name}",
				"text-font": ["Noto Sans Bold"],
				"text-size": ["interpolate", ["linear"], ["zoom"], 8, 10, 14, 16]
			},
			paint: {
				"text-color": "#a0a0c0",
				"text-halo-color": "#1a1a2e",
				"text-halo-width": 1.5
			}
		},
		{
			id: "place-city",
			type: "symbol",
			source: "openmaptiles",
			"source-layer": "place",
			filter: ["==", "class", "city"],
			minzoom: 5,
			layout: {
				"text-field": "{name}",
				"text-font": ["Noto Sans Bold"],
				"text-size": ["interpolate", ["linear"], ["zoom"], 5, 12, 14, 22]
			},
			paint: {
				"text-color": "#c0c0d8",
				"text-halo-color": "#1a1a2e",
				"text-halo-width": 2
			}
		}
	]
};
